import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog',
  template: `
  <div class="fx-col fx-justify-center fx-align-center pos-rel p-3 bg-white">
    <div class="fx-col w-full fx-justify-center mt-2">
      <div class="fx-row fx-align-center">
        <ion-icon
          *ngIf="icon && icon.type === 'ionic'"
          class="s-6 mr-3 {{icon.classes || ''}}"
          [color]="icon.color || 'warning'"
          [name]="icon.name || 'alert-circle'">
        </ion-icon>
        <ion-icon
          *ngIf="icon && icon.type === 'custom'"
          class="s-6 mr-3 {{icon.classes || ''}}"
          [src]="icon.src">
        </ion-icon>
        <div
          *ngIf="name"
          class="text-uppercase text-grey {{ nameClasses }}">
          {{ name }}
        </div>
      </div>
      <div
        *ngIf="description"
        class="capitalize-first my-3 text-300 text-greylight text-justify"
        style="line-height: 24px; white-space: pre-line">
        {{ description }}
      </div>
      <ion-item
        *ngIf="primary && !secondary"
        lines="none">
        <ion-button
          class="body-3 ion-button-grey ml-3 ml-auto overline text-bold text-white"
          expand="block"
          slot="end"
          (click)="primary.click()">
          <span class="text-uppercase">
            {{ primary.name }}
          </span>
        </ion-button>
      </ion-item>
      <ion-item
        *ngIf="primary && secondary"
        lines="none">
        <ion-button
          fill="clear"
          class="body-3 ml-auto overline text-500"
          style="color: var(--grey-500)"
          (click)="secondary.click()">
          <span class="text-uppercase">
            {{ secondary.name }}
          </span>
        </ion-button>
        <ion-button
          class="body-3 ion-button-grey ml-3 ml-auto overline text-bold text-white"
          slot="end"
          expand="block"
          (click)="primary.click()">
          <span class="text-uppercase">
            {{ primary.name }}
          </span>
        </ion-button>
      </ion-item>
    </div>
  </div>
  `,
  styles: [`
    ion-item {
      --inner-padding-end: 0;
    }
  `],
})
export class DialogComponent {
  @Input() icon?: {
    type: 'ionic';
    name?: string;
    color?: string;
    classes?: string;
  } | {
    type: 'custom';
    src: string;
    classes?: string;
  };
  @Input() name?: string;
  @Input() nameClasses = '';
  @Input() description?: string;
  @Input() primary?: {
    name?: string;
    click: () => void;
  };
  @Input() secondary?: {
    name?: string;
    click: () => void;
  };
}
